import {
  PDFArray,
  PDFDict,
  type PDFDocument,
  type PDFHexString,
  PDFName,
  type PDFRawStream,
  PDFStream,
  type PDFString,
  decodePDFRawStream,
} from "pdf-lib";

const extractRawAttachments = (pdfDoc: PDFDocument) => {
  if (!pdfDoc.catalog.has(PDFName.of("Names"))) return [];
  const Names = pdfDoc.catalog.lookup(PDFName.of("Names"), PDFDict);

  if (!Names.has(PDFName.of("EmbeddedFiles"))) return [];

  // make EmbeddedFiles mutable
  let EmbeddedFiles = Names.lookup(PDFName.of("EmbeddedFiles"), PDFDict);

  // when there's no /Name, but there are /Kids, take the first of /Kids instead
  if (
    !EmbeddedFiles.has(PDFName.of("Names")) &&
    EmbeddedFiles.has(PDFName.of("Kids"))
  )
    EmbeddedFiles = EmbeddedFiles.lookup(PDFName.of("Kids"), PDFArray).lookup(
      0,
    ) as PDFDict;

  if (!EmbeddedFiles.has(PDFName.of("Names"))) return [];
  const EFNames = EmbeddedFiles.lookup(PDFName.of("Names"), PDFArray);

  const rawAttachments = [];
  for (let idx = 0, len = EFNames.size(); idx < len; idx += 2) {
    const fileName = EFNames.lookup(idx) as PDFHexString | PDFString;
    const fileSpec = EFNames.lookup(idx + 1, PDFDict);
    rawAttachments.push({ fileName, fileSpec });
  }

  return rawAttachments;
};

export const extractPdfAttachments = (pdfDoc: PDFDocument) => {
  const rawAttachments = extractRawAttachments(pdfDoc);
  return rawAttachments.map(({ fileName, fileSpec }) => {
    const stream = fileSpec
      .lookup(PDFName.of("EF"), PDFDict)
      .lookup(PDFName.of("F"), PDFStream) as PDFRawStream;
    return {
      name: fileName.decodeText(),
      data: decodePDFRawStream(stream).decode(),
    };
  });
};
